import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CompanyAdminAPI } from "../api/apiClient";


export default function CompanyAdminLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("Please enter email and password");
      return;
    }


  

    try {
      const res = await CompanyAdminAPI.login(email, password);

      console.log("✅ Admin Login:", res);

     // navigate("/"); // redirect after login
      // ✅ ADD THIS
  localStorage.setItem("adminEmail", email);

   // ✅ 🔥 ADD THIS LINE (VERY IMPORTANT)
      localStorage.setItem("token", "admin");


  // ✅ CHANGE THIS
  navigate("/add-user");

    } 
    /*catch (err: any) {
      setError(err.message || "Login failed");
    }*/
   catch (err: any) {
  console.error("❌ Company Admin Login failed:", err);

  let message = "Login failed";

  try {
    const parsed = JSON.parse(err.message);
    message = parsed.message || message;
  } catch {
    message = err.message || message;
  }

  setError(message);
}
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8">

        <h2 className="text-2xl font-semibold text-center mb-6">
          Company Admin Login
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">

          <input
            type="email"
            placeholder="Admin Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border rounded-lg px-3 py-2"
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border rounded-lg px-3 py-2"
          />

          {error && (
            <div className="text-red-600 text-sm">{error}</div>
          )}

          <button className="w-full bg-green-600 text-white py-2 rounded-lg">
            Login
          </button>

        </form>

        <button
          onClick={() => navigate("/")}
          className="text-sm text-gray-600 hover:underline mt-4 w-full"
        >
          Back to User Login
        </button>

      </div>
    </div>
  );
}